import axios from 'axios'

export const findProspect = (id) => {
  return axios.post(`${window.location.origin}/api/FindProspect`, {
    ProspectId: id
  }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.data)
    .catch(error => error)
}

export const preparePayment = (payload) => {
  return axios.post(`${window.location.origin}/api/PreparePayment`, payload, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.data)
    .catch(error => error)
}

export const createCase = (payload, idempotencyKey = null) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  // Add idempotency key if provided
  if (idempotencyKey) {
    headers['Idempotency-Key'] = idempotencyKey
  }

  return axios.post(`${window.location.origin}/api/CreateCase`, payload, {
    headers
  })
    .then(response => response.data)
    .catch(error => {
      // Return error response for better error handling
      if (error.response) {
        return Promise.reject(error.response)
      }
      return Promise.reject(error)
    })
}

export const createProspect = (payload) => {
  return axios.post(`${window.location.origin}/api/CreateProspect?source=diplad`, payload, {
    headers: {
      Accept: 'application/json',
      'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.log('ERROR', error)
      return error
    })
}

export const createReport = (payload) => {
  const axiosInstance = axios.create({
    validateStatus: (status) => status
  })

  return axiosInstance.post(`${window.location.origin}/api/CreateReport`, payload, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}
